module.exports = __webpack_public_path__ + "files/dbbd86144126c778da4ab06eeb2f0fe3.png";